import React, { useEffect } from 'react';
import { Hero } from '../components/home/Hero';
import { TrustBar } from '../components/home/TrustBar';
import { IntentSelector } from '../components/home/IntentSelector';
import { Differentiation } from '../components/home/Differentiation';
import { Process } from '../components/home/Process';
import { FeeTransparency } from '../components/page/FeeTransparency';
import { ComplexMatters } from '../components/home/ComplexMatters';
import { TeamAuthority } from '../components/home/TeamAuthority';
import { Proof } from '../components/home/Proof';
import { Resources } from '../components/home/Resources';
import { FAQ } from '../components/home/FAQ';
import { FinalCTA } from '../components/home/FinalCTA';
export function Home() {
  useEffect(() => {
    document.title = 'Property Lawyers & Conveyancing Australia | L.A Property Law';
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Lawyer-led conveyancing and property law for Australian buyers, sellers and investors. Contract reviews, disclosure advice, SMSF matters and settlement support.');
    window.scrollTo(0, 0);
  }, []);
  return <main className="flex-1 w-full" data-id="element-648" data-mp="2hyp5yiad2upn">
      <Hero data-id="element-649" data-mp="2hzqkiwql5zc4" />
      <TrustBar data-id="element-650" data-mp="2d7731oos2k21" />
      <IntentSelector data-id="element-651" data-mp="2d6p3oj6tjppw" />
      <Differentiation data-id="element-652" data-mp="2d6f9ejeqqwee" />
      <TeamAuthority data-id="element-653" data-mp="2d5vyvnrf7aae" />
      <Proof data-id="element-654" data-mp="2883zk8og4lw6" />
      <Process data-id="element-655" data-mp="287uhd79n7j11" />
      <FeeTransparency data-id="element-656" data-mp="287chm0nrumod" />
      <ComplexMatters data-id="element-657" data-mp="288nh3oa6p89o" />
      <Resources data-id="element-658" data-mp="28618dlbk4mpv" />
      <FAQ data-id="element-659" data-mp="23911x9asphy8" />
      <FinalCTA data-id="element-660" data-mp="239j9h22wrilg" />
    </main>;
}